import { t } from "i18next";

import styles from "./NoAccessPage.module.scss";

const NoAccessPage = () => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.wrapper_description}>
        {t("You don't have access to this page")}
      </p>
    </div>
  );
};

export default NoAccessPage;
